import React, { useCallback, useEffect, useState, useMemo } from 'react'
import {
    Divider, Image, Grid, Empty,
    Skeleton, Toast, Dialog, Input, Popup, SearchBar
} from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import Icon from '../../icon';
import { getDinnerStatusMeta, isDinnerHostDisabled } from '../dinnerStatus';
import './index.css';
import { useAuth } from '../../app/providers/AuthProvider';
import { dinnerApi } from '../../features/dinner/api/dinnerApi';


const normalizeDateText = (value) => {
    if (!value) return '';
    return String(value).slice(0, 10);
};

const isDateExpired = (value) => {
    const dateText = normalizeDateText(value);
    if (!dateText) return false;
    // 聚餐当天仍可操作，只有当前日期超过聚餐日期后才限制普通用户。
    const [year, month, day] = dateText.split('-').map(Number);
    if (!year || !month || !day) return false;
    const dinnerDate = new Date(year, month - 1, day);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return today.getTime() > dinnerDate.getTime();
};

export default function DinnerInfo({ gameDetail, memberListInfo }) {

    const { memberInfo } = useAuth();
    const [dinnerInfo, setDinnerInfo] = useState({})
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    // Popup Logic
    const [isAddPopupShow, setIsAddPopupShow] = useState(false)
    const [addSearchKey, setAddSearchKey] = useState('')
    const [popupType, setPopupType] = useState('non-participant') // 'non-participant' | 'temp'

    const findUserInfo = (memberId) => {
        return memberListInfo?.find(user => user.id === memberId);
    };

    const getDinnerDetail = useCallback(() => {
        setShowLoading(false)
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        dinnerApi.getByGame(gameDetail.id)
            .then(function (response) {
                const detail = response.data.data
                if (detail) {
                    setDinnerInfo(detail)
                } else {
                    setDinnerInfo({})
                }
                setShowLoading(true)
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameDetail.id])

    useEffect(() => {
        getDinnerDetail()
    }, [getDinnerDetail])


    const joinDinner = (type, memberId) => {
        if (Number(memberInfo?.admin) !== 1 && isDateExpired(dinnerInfo?.dinnerDate || dinnerInfo?.createTime || gameDetail?.matchTime)) {
            return Toast.show({ content: '聚餐时间已过，无法再操作' });
        }
        Toast.show({
            icon: 'loading',
            duration: 0
        })
        const formData = new FormData();
        formData.append('memberId', memberId);
        formData.append('gameId', gameDetail.id)
        formData.append('type', type)
        dinnerApi.join(formData)
            .then(function (response) {
                const result = response.data
                if (result.code === 200) {
                    Toast.show({
                        icon: 'success',
                        content: "操作成功！",
                        afterClose: () => {
                            getDinnerDetail()
                            setIsAddPopupShow(false)
                        }
                    })
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: result.msg
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: "系统错误！",
                })
            })
    }

    const mainImage = (member) => {
        const image = member?.memberImageList
            ?.find(item => item.type === 0)
            ?.image
        if (image) {
            return image + Icon.ImageFooter;
        } else {
            return Icon.KEPENG_LOGO;
        }
    }

    const StatusSelectorContent = ({ currentType, onChange, status }) => {
        const options = [
            { label: '请客', value: 0, icon: '🍻', disabled: isDinnerHostDisabled(status) },
            { label: '报名', value: 1, icon: '✅' },
            { label: '待定', value: 2, icon: '⏳' },
            { label: '鸽子', value: 3, icon: '🐦' },
        ];

        const [selected, setSelected] = useState(currentType);

        const handleSelect = (val, disabled) => {
            if (disabled) return;
            setSelected(val);
            onChange(val);
        };

        return (
            <div className="status-selection-grid">
                {options.map(opt => (
                    <div
                        key={opt.value}
                        className={`status-selection-btn ${selected === opt.value ? 'selected' : ''} ${opt.disabled ? 'disabled' : ''}`}
                        onClick={() => handleSelect(opt.value, opt.disabled)}
                    >
                        <span className="status-btn-icon">{opt.icon}</span>
                        <span className="status-btn-label">{opt.label}</span>
                    </div>
                ))}
            </div>
        );
    };


    const renderMemberList = (type) => {
        const memberList = dinnerInfo?.members?.filter(item => item.type === type)
        if (memberList?.length > 0) {
            return (
                <Grid columns={5} gap={10}>
                    {memberList.map((item, index) => {
                        const userInfo = findUserInfo(item?.memberId);
                        return userInfo ? (
                            <Grid.Item key={index} className="dinner-member-item" onClick={() => {
                                if (memberInfo.admin === 1) {
                                    let selectorInfo = [type]
                                    Dialog.confirm({
                                        className: 'match-event-glass-dialog',
                                        title: '修改 ' + userInfo.name + ' 的状态',
                                        content: (
                                            <StatusSelectorContent
                                                currentType={type}
                                                status={dinnerInfo.status}
                                                onChange={(value) => selectorInfo = [value]}
                                            />
                                        ),
                                        onConfirm: () => {
                                            joinDinner(selectorInfo[0], userInfo.id)
                                        }
                                    })
                                }
                            }}>
                                <div className="dinner-member-avatar-wrapper">
                                    <Image
                                        src={mainImage(userInfo)}
                                        width={42}
                                        height={42}
                                        fit='cover'
                                        className={`dinner-member-avatar ${type === 0 ? 'host' : ''}`}
                                    />
                                </div>
                                <span className="dinner-member-name">{userInfo.name}</span>
                            </Grid.Item>
                        ) : null
                    })}
                </Grid>
            )
        } else {
            return <div style={{ padding: '12px 0', color: '#86909C', fontSize: '13px', textAlign: 'center' }}>暂无人选</div>
        }
    }

    const filteredNonSelectedMembers = memberListInfo?.filter(item => [0, 1, 2, 3, 4].includes(item.gameType) && !dinnerInfo?.members?.some(m => m.memberId === item.id));
    const filteredSelectedMembers = memberListInfo?.filter(item => !dinnerInfo?.members?.some(m => m.memberId === item.id) && item.tempMember === null);
    const tempSelectedMembers = memberListInfo?.filter(item => !dinnerInfo?.members?.some(m => m.memberId === item.id) && item.tempMember !== 2 && item.tempMember);

    // Memoized filtered popup list
    const popupFilteredList = useMemo(() => {
        const baseList = popupType === 'non-participant' ? filteredSelectedMembers : tempSelectedMembers;
        if (!addSearchKey) return baseList;
        return baseList?.filter(m => m.name?.toLowerCase().includes(addSearchKey.toLowerCase()));
    }, [addSearchKey, popupType, filteredSelectedMembers, tempSelectedMembers]);

    const dinnerExpired = isDateExpired(dinnerInfo?.dinnerDate || dinnerInfo?.createTime || gameDetail?.matchTime);
    const statusMeta = getDinnerStatusMeta(dinnerInfo?.status);

    const handleSelectProxy = (member) => {
        Dialog.confirm({
            className: 'match-event-glass-dialog',
            title: '代报确认',
            content: `确认代 [${member.name}] 报名聚餐吗？`,
            onConfirm: () => {
                joinDinner(1, member.id)
            }
        })
    }

    if (!showLoading) {
        return (
            <div style={{ padding: '20px' }}>
                <Skeleton.Title animated />
                <Skeleton.Paragraph lineCount={10} animated />
            </div>
        )
    }

    if (Object.keys(dinnerInfo).length === 0) {
        return (
            <div className="dinner-info-scope dinner-empty-state">
                <div className="dinner-empty-icon">🍽️</div>
                <div style={{ color: '#1D2129', fontSize: '18px', fontWeight: '800', marginBottom: '8px' }}>暂无聚餐安排</div>
                <div style={{ color: '#86909C', fontSize: '14px', marginBottom: '24px' }}>踢完球不聚餐，总觉得少了点什么</div>
                {memberInfo?.admin === 1 && (
                    <button className="premium-btn-base premium-btn-neon-orange" style={{ width: '200px' }} onClick={() => {
                        navigate('/createDinner', { state: { gameId: gameDetail.id } });
                    }}>
                        <span className="premium-btn-icon">✨</span> 发起聚餐
                    </button>
                )}
            </div>
        )
    }

    return (
        <div className="dinner-info-scope dinner-detail-wrapper">
            {/* Simplified Venue Text Card */}
            <div className="dinner-venue-card" style={{ marginBottom: '12px' }}>
                <div className="dinner-location-info">
                    <div className="dinner-location-title" style={{ fontSize: '17px' }}>
                        🍽️ {dinnerInfo.position || '聚餐地点'}
                    </div>
                    {dinnerInfo.address && (
                        <div className="dinner-location-address" style={{ marginTop: '6px', fontSize: '14px' }}>
                            {dinnerInfo.address}
                        </div>
                    )}
                </div>
            </div>

            {/* Status & Remark */}
            {dinnerInfo.status === 2 ? (
                <div className="dinner-status-alert cancelled">
                    <div style={{ fontWeight: 800 }}>⚠️ 聚餐已取消</div>
                    <div style={{ fontSize: '12px', opacity: 0.8 }}>原因：{dinnerInfo.cancelInfo || '暂无说明'}</div>
                </div>
            ) : (
                <>
                    {dinnerInfo.remark && (
                        <div className="dinner-remark-card">
                            <span className="dinner-remark-label">聚餐备注信息</span>
                            <div className="dinner-remark-text">{dinnerInfo.remark}</div>
                        </div>
                    )}

                    {statusMeta.alert ? (
                        <div className={`dinner-status-alert special ${statusMeta.className}`}>
                            <span>{Number(dinnerInfo.status) === 3 ? '🤝' : '⭐'}</span> {statusMeta.alert}
                        </div>
                    ) : null}
                </>
            )}

            {/* User Enrollment Actions */}
            {memberInfo && !memberInfo.temp && dinnerInfo.status !== 2 && (Number(memberInfo.admin) === 1 || (!dinnerExpired && gameDetail.statusInfo !== 3)) && (
                <div className="dinner-actions-card">
                    <div className="dinner-action-row">
                        <button
                            className="premium-action-btn orange"
                            onClick={() => joinDinner(0, memberInfo.id)}
                            disabled={dinnerInfo?.members?.some(item => item.type === 0 && item.memberId === memberInfo.id) || isDinnerHostDisabled(dinnerInfo.status)}
                        >
                            <span className="action-btn-icon">🍻</span>
                            <span className="action-btn-label">请客</span>
                        </button>
                        <button
                            className="premium-action-btn cyan"
                            onClick={() => joinDinner(1, memberInfo.id)}
                            disabled={dinnerInfo?.members?.some(item => item.type === 1 && item.memberId === memberInfo.id)}
                        >
                            <span className="action-btn-icon">✅</span>
                            <span className="action-btn-label">报名</span>
                        </button>
                        <button
                            className="premium-action-btn glass"
                            onClick={() => joinDinner(2, memberInfo.id)}
                            disabled={dinnerInfo?.members?.some(item => item.type === 2 && item.memberId === memberInfo.id)}
                        >
                            <span className="action-btn-icon">⏳</span>
                            <span className="action-btn-label">待定</span>
                        </button>
                    </div>

                    {memberInfo.admin === 1 && (
                        <div className="admin-action-row">
                            <button className="admin-btn-premium edit" onClick={() => navigate('/updateDinner', { state: { dinnerInfo } })}>
                                ✏️ 编辑计划
                            </button>
                            <button className="admin-btn-premium cancel" onClick={() => {
                                let cancelReason = ''
                                Dialog.confirm({
                                    className: 'match-event-glass-dialog',
                                    title: '取消聚餐确认',
                                    content: (
                                        <div style={{ padding: '8px 0' }}>
                                            <p style={{ color: '#86909C', marginBottom: '12px', fontSize: '13px' }}>告知大家取消的原因：</p>
                                            <Input placeholder="例如：天气原因、预订取消等" onChange={val => cancelReason = val} style={{ border: '1px solid #f1f5f9', padding: '8px', borderRadius: '8px', background: '#f8fafc' }} />
                                        </div>
                                    ),
                                    onConfirm: () => {
                                        dinnerApi.update({ dinnerId: dinnerInfo.id, status: 2, cancelReason })
                                            .then(res => {
                                                if (res.data.code === 200) {
                                                    Toast.show({ content: '已成功取消', icon: 'success', afterClose: () => getDinnerDetail() });
                                                } else {
                                                    Toast.show({ content: res.data.msg, icon: 'fail' });
                                                }
                                            });
                                    }
                                })
                            }}>
                                ❌ 取消活动
                            </button>
                        </div>
                    )}
                </div>
            )}
            {memberInfo && !memberInfo.temp && dinnerInfo.status !== 2 && dinnerExpired && Number(memberInfo.admin) !== 1 && (
                <div className="dinner-expired-tip">聚餐时间已过，报名和待定已关闭</div>
            )}

            {/* Member Participation Groups */}
            {!isDinnerHostDisabled(dinnerInfo.status) && (
                <div className="dinner-section">
                    <div className="dinner-section-header">
                        <div className="dinner-section-title">👑 慷慨请客</div>
                        <div className="dinner-section-count">{dinnerInfo?.members?.filter(i => i.type === 0).length || 0}人</div>
                    </div>
                    {renderMemberList(0)}
                </div>
            )}

            <div className="dinner-section">
                <div className="dinner-section-header">
                    <div className="dinner-section-title">⚽ 确认参加</div>
                    <div className="dinner-section-count">{dinnerInfo?.members?.filter(i => i.type === 1).length || 0}人</div>
                </div>
                {renderMemberList(1)}
            </div>

            <div className="dinner-section">
                <div className="dinner-section-header">
                    <div className="dinner-section-title">⏳ 待定中</div>
                    <div className="dinner-section-count">{dinnerInfo?.members?.filter(i => i.type === 2).length || 0}人</div>
                </div>
                {renderMemberList(2)}
            </div>

            {/* Admin Management Section */}
            {memberInfo.admin === 1 && (
                <div className="dinner-section">
                    <Divider className="dinner-divider">管理员：快速代报</Divider>

                    <div className="dinner-admin-quick-row">
                        <button className="dinner-quick-add-btn" onClick={() => {
                            setPopupType('non-participant')
                            setIsAddPopupShow(true)
                            setAddSearchKey('')
                        }}>
                            <div className="quick-add-info">
                                <span className="quick-add-title">非参赛队员</span>
                                <span className="quick-add-sub">代报科朋正式成员</span>
                            </div>
                        </button>
                        <button className="dinner-quick-add-btn" onClick={() => {
                            setPopupType('temp')
                            setIsAddPopupShow(true)
                            setAddSearchKey('')
                        }}>
                            <div className="quick-add-info">
                                <span className="quick-add-title">临时客串</span>
                                <span className="quick-add-sub">代报临时/访客人员</span>
                            </div>
                        </button>
                    </div>

                    {filteredNonSelectedMembers?.length > 0 && (
                        <div style={{ marginTop: '20px' }}>
                            <div className="dinner-section-title" style={{ fontSize: '12px', color: '#86909C', marginBottom: '10px' }}>🏃 参赛未报人员</div>
                            <Grid columns={5} gap={10}>
                                {filteredNonSelectedMembers.map((member, index) => (
                                    <Grid.Item key={index} className="dinner-member-item" onClick={() => handleSelectProxy(member)}>
                                        <div className="dinner-member-avatar-wrapper">
                                            <Image src={mainImage(member)} width={36} height={36} fit='cover' className="dinner-member-avatar" />
                                        </div>
                                        <span className="dinner-member-name">{member.name}</span>
                                    </Grid.Item>
                                ))}
                            </Grid>
                        </div>
                    )}
                </div>
            )}

            {/* Bottom Search Popup */}
            <Popup
                visible={isAddPopupShow}
                onMaskClick={() => setIsAddPopupShow(false)}
                bodyStyle={{ height: '70vh', display: 'flex', flexDirection: 'column', borderTopLeftRadius: '24px', borderTopRightRadius: '24px', overflow: 'hidden' }}
            >
                <div className="dinner-popup-header">
                    <div className="dinner-popup-title">
                        {popupType === 'non-participant' ? '代报：非参赛队员' : '代报：临时客串人员'}
                    </div>
                    <SearchBar
                        placeholder='输入姓名快速搜索...'
                        style={{ '--background': '#f2f3f5', '--border-radius': '12px' }}
                        onChange={val => setAddSearchKey(val)}
                        onClear={() => setAddSearchKey('')}
                    />
                </div>
                <div className="dinner-popup-body">
                    {popupFilteredList?.length > 0 ? (
                        <Grid columns={4} gap={8}>
                            {popupFilteredList.map(member => (
                                <Grid.Item key={member.id} className="popup-member-card" onClick={() => handleSelectProxy(member)}>
                                    <span className="popup-member-name">{member.name}</span>
                                </Grid.Item>
                            ))}
                        </Grid>
                    ) : (
                        <Empty description="未找到匹配的成员" imageStyle={{ width: 60 }} style={{ marginTop: '40px' }} />
                    )}
                </div>
            </Popup>
        </div>
    )
}
